<div class="export-template-list">
  <div class="toolbar">
    <h6>{{ "company-export-templates.title.export-templates" | translate }}</h6>
    <sui-button
      variant="primary"
      [leadingIcon]="['fas', 'plus']"
      (click)="createExportTemplate()"
    >
      {{ "company-export-templates.button.create-export-template" | translate }}
    </sui-button>
  </div>

  <ul class="nav nav-tabs nav-fill">
    @for (format of formats; track format.id) {
      <li class="nav-item">
        <button
          type="button"
          class="nav-link"
          [class.active]="format.id === activeFormat.id"
          (click)="onTabClick(format)"
        >
          {{ format.label }}
        </button>
      </li>
    }
  </ul>

  <!-- State messages -->
  @if (loading) {
    <app-loading></app-loading>
  }

  @if (error) {
    <div class="state state--error">
      {{ error }}
    </div>
  }

  @if (!loading && !error && templates.length === 0) {
    <div class="state">
      No {{ activeFormat.label }} templates found for this company.
    </div>
  }

  <!-- Cards grid -->
  @if (!loading && !error && templates.length > 0) {
    <div class="template-grid">
      @for (template of templates; track trackByTemplateId($index, template)) {
        <div
          class="template-card"
          [class.template-card--default]="template.is_default"
        >
          <div class="template-card__thumbnail">
            <img
              [src]="getTemplateThumbnailUrl(template)"
              [alt]="template.name"
              loading="lazy"
            />

            @if (template.is_default) {
              <span class="template-card__badge"> Default </span>
            }
          </div>

          <div class="template-card__body">
            <div class="template-card__header">
              <div class="template-card__title" [title]="template.name">
                {{ template.name }}
              </div>

              <span class="template-card__format">
                {{ getFormatLabel(template) }}
              </span>
            </div>

            <div class="template-card__meta">
              <div class="template-card__meta-row">
                <span class="template-card__meta-label">Language</span>
                <span class="template-card__meta-value">
                  {{ template.language.name }}
                </span>
              </div>

              <div class="template-card__meta-row" [title]="template.file_path">
                <span class="template-card__meta-label">File</span>
                <span
                  class="template-card__meta-value template-card__meta-value--truncate"
                >
                  {{ template.file_path }}
                </span>
              </div>

              @if (template.time_modified) {
                <div class="template-card__meta-row">
                  <span class="template-card__meta-label">Updated</span>
                  <span class="template-card__meta-value">
                    {{ template.time_modified.absolute }}
                  </span>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- Table -->
</div>
